<template>
    <ConfirmDialog />
    <Toast />
    <div class="grid nested-grid">
        <div class="col-12">
            <div class="card fluid cardheader agreements-header-card">
                <div class="col-12">
                    <h5 class="stationsHeader">{{ translated('receivingAgreementsTitle') }}</h5>
                    <div class="agreement-context mt-2">
                        <div><strong>{{ translated('financedName') }}:</strong> {{ financedName }}</div>
                        <div><strong>{{ translated('companyname') }}:</strong> {{ companyName }}</div>
                    </div>
                </div>
            </div>

            <DataTable :value="agreements" class="p-datatable-sm" removableSort showGridlines dataKey="Id"
                v-model:filters="filters1" :loading="loading1" responsiveLayout="scroll" :rowHover="true"
                :globalFilterFields="['Name']">
                <template #header>
                    <div class="flex justify-content-between">
                        <Button :label="translated('receivingAgreementNew')" :disabled="!isMAdmin" icon="pi pi-plus" class="p-button" @click="openModalAddAgreement()" />
                        <span class="p-input-icon-right">
                            <i class="pi pi-search" />
                            <InputText v-model="filters1['global'].value" :placeholder="translated('keywordsearch')" />
                        </span>
                    </div>
                </template>
                <template #empty>
                    No receiving agreements found.
                </template>
                <template #loading>
                    Loading receiving agreements. Please wait.
                </template>

                <Column :header="translated('receivingAgreementName')" field="Name" :sortable="true"></Column>
                <Column :header="translated('receivingAgreementSignedDate')">
                    <template #body="slotProps">
                        {{ formatDate(slotProps.data.SignedDate) }}
                    </template>
                </Column>
                <Column :exportable="false" :style="{width:'90px'}" bodyStyle="text-align: right">
                    <template #body="slotProps">
                        <div class="action-buttons">
                            <Button :disabled="!isMAdmin" icon="pi pi-pencil" class="p-button-rounded p-button-success" @click="openModalEditAgreement(slotProps.data)" />
                            <Button :disabled="!isMAdmin" icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="deleteAgreement(slotProps.data)" />
                        </div>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>

    <Dialog v-model:visible="displayModalAgreement" :style="{width: '32vw'}" :modal="true" class="globalDialog">
        <template #header>
            <span class="p-dialog-title">{{ popupTitle }}</span>
        </template>
        <div class="card fluid">
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('receivingAgreementName') }}</label>
                <div class="col-12 md:col-8">
                    <InputText type="text" v-model="tmpName" />
                </div>
            </div>
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('receivingAgreementSignedDate') }}</label>
                <div class="col-12 md:col-8">
                    <Calendar v-model="tmpSignedDate" dateFormat="dd. mm. yy" showIcon :manualInput="false" style="width: 100%;" />
                </div>
            </div>
        </div>
        <template #footer>
            <Button :label="translated('canclebutton')" icon="pi pi-times" @click="closeModalAgreement" class="p-button-text"/>
            <Button :disabled="!isMAdmin" :label="translated('savebutton')" icon="pi pi-check" @click="saveAgreement" autofocus />
        </template>
    </Dialog>
</template>

<script>
import { FilterMatchMode } from 'primevue/api';
import createHttp from "@/services/http";
import { computed } from "vue";
import store from "@/store";
import Calendar from 'primevue/calendar';

export default {
    components: { Calendar },
    props: ['financedId', 'companyId'],
    data() {
        return {
            translated: computed(() => store.getters.getTranslate),
            agreements: [],
            companiesLookup: {},
            financedLookup: {},
            filters1: null,
            loading1: true,
            displayModalAgreement: false,
            popupTitle: '',
            tmpId: '',
            tmpName: '',
            tmpSignedDate: null,
            isNewAgreement: false
        };
    },
    created() {
        this.initFilters1();
    },
    async mounted() {
        await this.loadData();
    },
    computed: {
        isMAdmin() {
            return this.$store.getters.isInRole("MAdmin");
        },
        apiBaseUrl() {
            return process.env.VUE_APP_API_FOLDER;
        },
        financedName() {
            return this.financedLookup[this.financedId]?.Name || '';
        },
        companyName() {
            return this.companiesLookup[this.companyId]?.Name || '';
        }
    },
    methods: {
        initFilters1() {
            this.filters1 = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS }
            };
        },
        formatDate(dateTime) {
            if (!dateTime) {
                return '';
            }

            const d = new Date(dateTime);
            return d.toLocaleDateString('sl-SI', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        },
        formatForServer(date) {
            if (!date) {
                return null;
            }

            const d = date instanceof Date ? date : new Date(date);
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        },
        async loadData() {
            this.loading1 = true;
            const http = createHttp(true);

            const [agreementsResult, companiesResult, financedResult] = await Promise.all([
                http.get(this.apiBaseUrl + "/GetReceivingAgreements"),
                http.get(this.apiBaseUrl + "/GetReceivingSupportCompanies"),
                http.get(this.apiBaseUrl + "/GetFinanceRecords")
            ]);

            const allAgreements = agreementsResult.status === 200 ? agreementsResult.data : [];
            this.agreements = allAgreements.filter(x => x.FinancedId === this.financedId && x.ReceivingSupportCompanyId === this.companyId);

            const companies = companiesResult.status === 200 ? companiesResult.data : [];
            this.companiesLookup = companies.reduce((acc, item) => {
                acc[item.Id] = item;
                return acc;
            }, {});

            const financed = financedResult.status === 200 ? financedResult.data : [];
            this.financedLookup = financed.reduce((acc, item) => {
                acc[item.Id] = item;
                return acc;
            }, {});

            this.loading1 = false;
        },
        openModalAddAgreement() {
            this.popupTitle = this.translated('receivingAgreementNew');
            this.isNewAgreement = true;
            this.tmpId = crypto.randomUUID();
            this.tmpName = '';
            this.tmpSignedDate = null;
            this.displayModalAgreement = true;
        },
        openModalEditAgreement(agreement) {
            this.popupTitle = this.translated('receivingAgreementEdit');
            this.isNewAgreement = false;
            this.tmpId = agreement.Id;
            this.tmpName = agreement.Name;
            this.tmpSignedDate = agreement.SignedDate ? new Date(agreement.SignedDate) : null;
            this.displayModalAgreement = true;
        },
        closeModalAgreement() {
            this.displayModalAgreement = false;
        },
        async saveAgreement() {
            const http = createHttp(true);
            const agreement = {
                Id: this.tmpId,
                ReceivingSupportCompanyId: this.companyId,
                FinancedId: this.financedId,
                Name: this.tmpName,
                SignedDate: this.formatForServer(this.tmpSignedDate)
            };

            try {
                const response = await http.post(this.apiBaseUrl + "/SaveReceivingAgreements", [agreement]);
                if (response.status === 200) {
                    await this.loadData();
                    this.$toast.add({ severity:'success', summary:'Confirmed', detail:'Record saved!', life: 3000 });
                    this.displayModalAgreement = false;
                }
            } catch (error) {
                const detail = error?.response?.data?.message || 'ERROR';
                this.$toast.add({ severity:'error', summary:'Error', detail, life: 5000 });
            }
        },
        deleteAgreement(agreement) {
            this.$confirm.require({
                message: this.translated('receivingAgreementDeleteQuestion'),
                header: this.translated('deletetitle'),
                icon: 'pi pi-exclamation-triangle',
                acceptClass: 'p-button-danger',
                accept: async () => {
                    const http = createHttp(true);
                    try {
                        const response = await http.delete(this.apiBaseUrl + "/DeleteReceivingAgreement?id=" + agreement.Id);
                        if (response.status === 200) {
                            await this.loadData();
                            this.$toast.add({ severity:'success', summary:'Confirmed', detail:'Record deleted', life: 3000 });
                        }
                    } catch (error) {
                        const detail = error?.response?.data?.message || 'ERROR';
                        this.$toast.add({ severity:'error', summary:'Error', detail, life: 5000 });
                    }
                }
            });
        }
    }
}
</script>

<style scoped>
.agreement-context {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 0.5rem 1rem;
    overflow-wrap: anywhere;
    word-break: break-word;
}

.agreement-context > div {
    min-width: 0;
}

.action-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.5rem;
}

.agreements-header-card {
    height: auto;
}
</style>
